"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabContent = TabContent;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _get = _interopRequireDefault(require("lodash/get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function TabContent(_ref) {
  var tab = _ref.tab,
      selected = _ref.selected;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames2.default)('frikin-tab-content', "frikin-tab-content-".concat(tab.tabKey), {
      'is-active': selected
    })
  }, tab.content);
}

var Tabs = /*#__PURE__*/function (_React$Component) {
  _inherits(Tabs, _React$Component);

  var _super = _createSuper(Tabs);

  function Tabs() {
    var _this;

    _classCallCheck(this, Tabs);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {};
    _this.onTabChange = typeof _this.props.onTabChange === 'function' ? _this.props.onTabChange : function (tabKey) {
      return _this.setState({
        selectedTabKey: _this.props.togglable && _this.state.selectedTabKey === tabKey ? null : tabKey
      });
    };

    _this.getTabs = function (tabs) {
      return tabs.map(function (t) {
        var tabClass = (0, _classnames2.default)('tab', 'frikin-tab', "frikin-tab-".concat(t.tabKey), {
          'is-active': _this.state.selectedTabKey === t.tabKey,
          'is-disabled': t.disabled
        });
        return /*#__PURE__*/_react.default.createElement("li", {
          key: t.tabKey,
          className: tabClass
        }, /*#__PURE__*/_react.default.createElement("a", {
          //href={`#${t.tabKey}`}
          onClick: function onClick() {
            return !t.disabled && _this.onTabChange(t.tabKey, _this.state.selectedTabKey);
          }
        }, t.label));
      });
    };

    _this.getPersistedTabContent = function (tabs, selectedTabKey) {
      return tabs.map(function (t) {
        return /*#__PURE__*/_react.default.createElement(TabContent, {
          key: t.tabKey,
          tab: t,
          selected: selectedTabKey === t.tabKey
        });
      });
    };

    _this.getFilteredTabContent = function (tabs, selectedTabKey) {
      var tab = tabs.find(function (t) {
        return t.tabKey === selectedTabKey;
      });
      return tab && /*#__PURE__*/_react.default.createElement(TabContent, {
        tab: tab,
        selected: true
      });
    };

    return _this;
  }

  _createClass(Tabs, [{
    key: "render",
    value: function render() {
      var _classnames;

      var _this$props = this.props,
          tabs = _this$props.tabs,
          persistContent = _this$props.persistContent,
          size = _this$props.size,
          centered = _this$props.centered,
          boxed = _this$props.boxed,
          toggle = _this$props.toggle,
          rounded = _this$props.rounded,
          fullwidth = _this$props.fullwidth,
          tabControls = _this$props.tabControls,
          className = _this$props.className,
          selectedTabKey = this.state.selectedTabKey;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames2.default)('frikin-tabs-wrapper', className)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames2.default)('tabs', 'frikin-tabs', (_classnames = {}, _defineProperty(_classnames, "is-".concat(size), size !== 'regular'), _defineProperty(_classnames, 'is-centered', centered), _defineProperty(_classnames, 'is-boxed', boxed), _defineProperty(_classnames, 'is-toggle', toggle), _defineProperty(_classnames, 'is-toggle-rounded', rounded), _defineProperty(_classnames, 'is-fullwidth', fullwidth), _defineProperty(_classnames, 'has-controls', !!tabControls), _classnames))
      }, /*#__PURE__*/_react.default.createElement("ul", null, this.getTabs(tabs)), tabControls && /*#__PURE__*/_react.default.createElement("div", {
        className: "frikin-tab-controls"
      }, tabControls)), /*#__PURE__*/_react.default.createElement("div", {
        className: "frikin-tabs-content"
      }, persistContent ? this.getPersistedTabContent(tabs, selectedTabKey) : this.getFilteredTabContent(tabs, selectedTabKey)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (!props.selectedTabKey && !props.onTabChange && !state.selectedTabKey) {
        return {
          selectedTabKey: (0, _get.default)(props.tabs, '[0].tabKey')
        };
      } else if (props.selectedTabKey && props.onTabChange) {
        return {
          selectedTabKey: props.selectedTabKey
        };
      } else {
        return state;
      }
    }
  }]);

  return Tabs;
}(_react.default.Component);

exports.default = Tabs;
Tabs.propTypes = {
  selectedTabKey: _propTypes.default.string,
  persistContent: _propTypes.default.bool,
  tabs: _propTypes.default.arrayOf(_propTypes.default.shape({
    tabKey: _propTypes.default.string.isRequired,
    label: _propTypes.default.any.isRequired,
    content: _propTypes.default.any,
    disabled: _propTypes.default.bool
  })).isRequired,
  onTabChange: _propTypes.default.func,
  size: _propTypes.default.oneOf(['regular', 'small', 'medium', 'large']),
  centered: _propTypes.default.bool,
  boxed: _propTypes.default.bool,
  toggle: _propTypes.default.bool,
  rounded: _propTypes.default.bool,
  fullwidth: _propTypes.default.bool,
  tabsControls: _propTypes.default.any
};
Tabs.defaultProps = {
  size: 'regular'
};